var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBriefcase = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 30,
  height: 30,
  viewBox: "7 7 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M17.5 19a.5.5 0 0 0 .5-.5V18h5v4a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1v-4h5v.5a.5.5 0 0 0 .5.5zm1.5-9h3a1 1 0 0 1 1 1v6h-5v-1.5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0-.5.5V17H7v-6a1 1 0 0 1 1-1h3V8a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1zm-6 0h4V9h-4zm4 6.5v1a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5"
})));
export default SvgBriefcase;